import { render, staticRenderFns } from "./TatChartList.vue?vue&type=template&id=f55e40c0"
import script from "./TatChartList.vue?vue&type=script&lang=js"
export * from "./TatChartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports